import styled from 'styled-components'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'

export const DriveSpan = styled.span`
  font-style: normal;
  font-weight: ${props => (props?.bold ? FONT.FW_900 :FONT.FW_500)};
  font-size: ${FONT.F_XS};
  line-height: 15px;
  color: ${props => (props?.bold ? COLORS.GREY_T_70 : COLORS.GREY_T_60)};
  text-transform: capitalize;
  opacity: 0.89;
`
